import { getAllAB, getAllABSync, isB } from 'root/common/abTest';
import PrivilegeState from '@/common/thirdParty/privilege/state';
import env from '@/common/util/env';

// 订单聚合灰度控制
export const OrderListGrayScale = {
    on: true, // 开启灰度
    role: 'B', // 关掉灰度之后走 A 还是 B
    orderTypeToAbTestKey: {
        priv_gas: 'gasOrderPage',
        priv_gasRecharge: 'gasOrderPage',
        priv_gasCard: 'gasOrderPage',
        priv_gasCardRecharge: 'gasOrderPage',
        priv_carWash: 'gasOrderPage',
        priv_movie: 'movieOrderPage',
        priv_hero: 'heroOrderPage',
        priv_rechargeNormal: 'rechargeOrderPage',
        priv_rechargeGas: 'rechargeOrderPage',
        priv_rechargeGame: 'rechargeOrderPage',
        priv_kfc: 'kfcOrderPage',
        priv_packet: 'packetOrderPage',
        priv_ticket: 'ticketOrderPage',
        priv_supermarket: 'supermarketOrderPage',
        priv_flight: 'flightOrderPage',
        priv_ctripHotel: 'ctripHotelOrderPage',
        priv_groupon: 'grouponOrderPage',
        priv_photo: 'photoOrderPage',
    },
    init() {
        if (this.on) {
            getAllAB();
        }
    },
    initSync() {
        if (this.on) {
            getAllABSync().then(console.log);
        }
    },
    getAllABSync() {
        if (this.on) {
            return getAllABSync();
        }
        return Promise.resolve();
    },
    isB(key) {
        if (this.on) {
            return isB(key);
        }
        return this.role === 'B';
    },
    getOrderListUrl(orderType, oldOrderListUrl, singleOrderType) {
        const isSourceChannel = !!PrivilegeState.get();
        // b 版用户跳转聚合订单列表
        if (!isSourceChannel && this.isB(this.orderTypeToAbTestKey[orderType])) {
            let url = '/new/orderList/index.html?ZZCAppArg=AppOpenPage,topbar_remove';
            if (singleOrderType) {
                url += `&orderType=${orderType}`;
                return url;
            }
            if (env.isMainMiniProgram) {
                url += '&orderType=priv_kfc,priv_ticket,priv_rechargeNormal,priv_gas';
            }
            return url;
        }

        return oldOrderListUrl;
    },
    goOrderList(orderType, oldOrderListUrl, singleOrderType) {
        let url = '/new/orderList/index.html?ZZCAppArg=AppOpenPage,topbar_remove';
        if (singleOrderType) {
            url += `&orderType=${orderType}`;
            return url;
        }
        if (env.isMainMiniProgram) {
            url += '&orderType=priv_kfc,priv_ticket,priv_rechargeNormal,priv_gas';
        }
        window.location.href = url;
    },
    // singleOrderType 是否只显示一种订单类型（传入的orderType）
    jumpOrderList(orderType, oldOrderListUrl, singleOrderType) {
        window.location.href = this.getOrderListUrl(orderType, oldOrderListUrl, singleOrderType);
    },
};
